import { EQUIPMENT_SLOT, ITEM_TYPE_TO_SLOT } from './constants';

export const ALL_SLOTS = [
    EQUIPMENT_SLOT.WEAPON,
    EQUIPMENT_SLOT.ARMOR,
    EQUIPMENT_SLOT.HELM,
    EQUIPMENT_SLOT.ACCESSORY,
];

// Maps an item type to its equipment slot, or null if non-equipable.
export const getSlotForItem = (item) => {
    if (!item) return null;
    return ITEM_TYPE_TO_SLOT[item.type] || null;
};

// Sums every flat stat bonus across all currently-equipped items.
// Returns { strength: 0, intelligence: 0, dexterity: 0, vitality: 0,
// maxHealth: 0, maxMana: 0 } at minimum.
export const getEquipmentBonus = (hero) => {
    const acc = {
        strength: 0,
        intelligence: 0,
        dexterity: 0,
        vitality: 0,
        maxHealth: 0,
        maxMana: 0,
    };
    if (!hero || !hero.equipment) return acc;

    for (const slot of ALL_SLOTS) {
        const item = hero.equipment[slot];
        if (!item || !item.bonuses) continue;
        for (const stat of Object.keys(acc)) {
            if (typeof item.bonuses[stat] === 'number') {
                acc[stat] += item.bonuses[stat];
            }
        }
    }
    return acc;
};

// Returns the hero's effective stats: base stats + equipment bonuses.
// Pure function — no mutation. Use this every time a saga / component
// needs to read a stat for game logic (damage, defense, etc.).
// `health` and `mana` (current values) are not bonused — only their max
// caps grow when equipping. Current health/mana stay where they are; the
// next heal can fill up to the new cap.
export const getEffectiveStats = (hero) => {
    const base = hero?.stats || {};
    const bonus = getEquipmentBonus(hero);
    return {
        ...base,
        strength: (base.strength || 0) + bonus.strength,
        intelligence: (base.intelligence || 0) + bonus.intelligence,
        dexterity: (base.dexterity || 0) + bonus.dexterity,
        vitality: (base.vitality || 0) + bonus.vitality,
        maxHealth: (base.maxHealth || 0) + bonus.maxHealth,
        maxMana: (base.maxMana || 0) + bonus.maxMana,
    };
};
